<template>
  <v-expansion-panels
    :class="{ 'not-exist-files': !data.fileLink && !data.customParameters }"
  >
    <v-expansion-panel
      class="history-item"
      :disabled="!data.fileLink && !data.customParameters"
    >
      <v-expansion-panel-header>
        <div class="header">
          <StatusIcon :size="35" :type="this.data.typeStatus" class="icon" />
          <div class="d-flex flex-column">
            <span class="title"
              >{{ data.statusName }} -
              {{ data.statusDate | dateWithTime }}</span
            >
            <span class="sub-title">{{ data.statusDescription }}</span>
          </div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <StatusInfo
          :data="data"
          :once="true"
          :statement-status-info="statementStatusInfo"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { dateWithTime } from '@/filters';
import StatusInfo from '@/components/elements/statement/Status/StatusInfo';
import StatusIcon from '@/components/elements/statement/Status/StatusIcon';

export default {
  name: 'History',
  components: { StatusIcon, StatusInfo },
  props: ['data', 'statementStatusInfo'],
  filters: {
    dateWithTime,
  },
};
</script>

<style scoped lang="scss">
.not-exist-files {
  & .v-expansion-panel-header {
    cursor: default !important;
  }

  &::v-deep .v-expansion-panel-header__icon {
    display: none !important;
  }
}

.history-item {
  width: 100%;
  border-top: 1px solid $color-grey;
  border-bottom: 1px solid $color-grey;

  &::before {
    box-shadow: none !important;
  }

  &:first-child {
    border-top: none !important;
  }

  & .title {
    font-weight: 600;
    color: $color-base;
    font-size: $font-size-base !important;
  }

  &::v-deep .v-expansion-panel-header__icon {
    background: #b2bccf;
    border-radius: 26px;
    padding: 2px;

    & .v-icon {
      color: white !important;
    }
  }

  & .files {
    margin-top: 30px;
  }

  & .files-list {
    padding: 20px 0 0;

    & .file {
      display: flex;
      align-items: baseline;
      margin-bottom: 20px;
    }

    & .icon {
      margin-right: 5px;
      padding-top: 5px;
    }

    & .name {
      color: $color-base;
      font-weight: 500;
      font-size: $font-size-small;
    }

    & .link {
      font-size: $font-size-small;
    }
  }

  & .header {
    display: flex;
    flex-direction: row;
    align-items: center;

    & .icon {
      margin-right: 10px;
    }

    & .sub-title {
      color: $color-base;
      font-size: $font-size-small;
    }
  }
}
</style>
